// Chart
export const TOP_SALES_DATA = [
	{
		x: "2020-01-01",
		y: 150,
	},
	{
		x: "2020-01-02",
		y: 160,
	},
	{
		x: "2020-01-03",
		y: 170,
	},
	{
		x: "2020-01-04",
		y: 161,
	},
	{
		x: "2020-01-05",
		y: 167,
	},
	{
		x: "2020-01-06",
		y: 162,
	},
	{
		x: "2020-01-07",
		y: 152,
	},
	{
		x: "2020-01-08",
		y: 141,
	},
	{
		x: "2020-01-09",
		y: 144,
	},
	{
		x: "2020-01-10",
		y: 154,
	},
	{
		x: "2020-01-11",
		y: 166,
	},
	{
		x: "2020-01-12",
		y: 176,
	},
	{
		x: "2020-01-13",
		y: 187,
	},
	{
		x: "2020-01-14",
		y: 198,
	},
	{
		x: "2020-01-15",
		y: 210,
	},
	{
		x: "2020-01-16",
		y: 196,
	},
	{
		x: "2020-01-17",
		y: 207,
	},
	{
		x: "2020-01-18",
		y: 200,
	},
	{
		x: "2020-01-19",
		y: 187,
	},
	{
		x: "2020-01-20",
		y: 192,
	},
	{
		x: "2020-01-21",
		y: 204,
	},
	{
		x: "2020-01-22",
		y: 193,
	},
	{
		x: "2020-01-23",
		y: 204,
	},
	{
		x: "2020-01-24",
		y: 208,
	},
	{
		x: "2020-01-25",
		y: 196,
	},
	{
		x: "2020-01-26",
		y: 193,
	},
	{
		x: "2020-01-27",
		y: 178,
	},
	{
		x: "2020-01-28",
		y: 191,
	},
	{
		x: "2020-01-29",
		y: 204,
	},
	{
		x: "2020-01-30",
		y: 218,
	},
	{
		x: "2020-01-31",
		y: 211,
	},
	{
		x: "2020-02-01",
		y: 216,
	},
	{
		x: "2020-02-02",
		y: 201,
	},
	{
		x: "2020-02-03",
		y: 197,
	},
	{
		x: "2020-02-04",
		y: 190,
	},
	{
		x: "2020-02-05",
		y: 179,
	},
	{
		x: "2020-02-06",
		y: 172,
	},
	{
		x: "2020-02-07",
		y: 158,
	},
	{
		x: "2020-02-08",
		y: 159,
	},
	{
		x: "2020-02-09",
		y: 147,
	},
	{
		x: "2020-02-10",
		y: 152,
	},
	{
		x: "2020-02-11",
		y: 144,
	},
	{
		x: "2020-02-12",
		y: 137,
	},
	{
		x: "2020-02-13",
		y: 136,
	},
	{
		x: "2020-02-14",
		y: 123,
	},
	{
		x: "2020-02-15",
		y: 112,
	},
	{
		x: "2020-02-16",
		y: 99,
	},
	{
		x: "2020-02-17",
		y: 100,
	},
	{
		x: "2020-02-18",
		y: 95,
	},
	{
		x: "2020-02-19",
		y: 105,
	},
	{
		x: "2020-02-20",
		y: 116,
	},
	{
		x: "2020-02-21",
		y: 125,
	},
	{
		x: "2020-02-22",
		y: 124,
	},
	{
		x: "2020-02-23",
		y: 133,
	},
	{
		x: "2020-02-24",
		y: 129,
	},
	{
		x: "2020-02-25",
		y: 116,
	},
	{
		x: "2020-02-26",
		y: 119,
	},
	{
		x: "2020-02-27",
		y: 109,
	},
	{
		x: "2020-02-28",
		y: 114,
	},
	{
		x: "2020-03-01",
		y: 115,
	},
	{
		x: "2020-03-02",
		y: 111,
	},
	{
		x: "2020-03-03",
		y: 96,
	},
	{
		x: "2020-03-04",
		y: 104,
	},
	{
		x: "2020-03-05",
		y: 104,
	},
	{
		x: "2020-03-06",
		y: 102,
	},
	{
		x: "2020-03-07",
		y: 116,
	},
	{
		x: "2020-03-08",
		y: 126,
	},
	{
		x: "2020-03-09",
		y: 117,
	},
	{
		x: "2020-03-10",
		y: 130,
	},
	{
		x: "2020-03-11",
		y: 124,
	},
	{
		x: "2020-03-12",
		y: 126,
	},
	{
		x: "2020-03-13",
		y: 131,
	},
	{
		x: "2020-03-14",
		y: 143,
	},
	{
		x: "2020-03-15",
		y: 130,
	},
	{
		x: "2020-03-16",
		y: 116,
	},
	{
		x: "2020-03-17",
		y: 118,
	},
	{
		x: "2020-03-18",
		y: 122,
	},
	{
		x: "2020-03-19",
		y: 132,
	},
	{
		x: "2020-03-20",
		y: 126,
	},
	{
		x: "2020-03-21",
		y: 136,
	},
	{
		x: "2020-03-22",
		y: 123,
	},
	{
		x: "2020-03-23",
		y: 112,
	},
	{
		x: "2020-03-24",
		y: 116,
	},
	{
		x: "2020-03-25",
		y: 113,
	},
	{
		x: "2020-03-26",
		y: 113,
	},
	{
		x: "2020-03-27",
		y: 109,
	},
	{
		x: "2020-03-28",
		y: 99,
	},
	{
		x: "2020-03-29",
		y: 100,
	},
	{
		x: "2020-03-30",
		y: 95,
	},
	{
		x: "2020-03-31",
		y: 83,
	},
	{
		x: "2020-04-01",
		y: 79,
	},
	{
		x: "2020-04-02",
		y: 64,
	},
	{
		x: "2020-04-03",
		y: 79,
	},
	{
		x: "2020-04-04",
		y: 81,
	},
	{
		x: "2020-04-05",
		y: 94,
	},
	{
		x: "2020-04-06",
		y: 99,
	},
	{
		x: "2020-04-06",
		y: 97,
	},
	{
		x: "2020-04-07",
		y: 83,
	},
	{
		x: "2020-04-08",
		y: 71,
	},
	{
		x: "2020-04-09",
		y: 75,
	},
	{
		x: "2020-04-10",
		y: 69,
	},
	{
		x: "2020-04-11",
		y: 71,
	},
	{
		x: "2020-04-12",
		y: 75,
	},
	{
		x: "2020-04-13",
		y: 84,
	},
	{
		x: "2020-04-14",
		y: 90,
	},
	{
		x: "2020-04-15",
		y: 100,
	},
	{
		x: "2020-04-16",
		y: 96,
	},
	{
		x: "2020-04-16",
		y: 108,
	},
	{
		x: "2020-04-17",
		y: 102,
	},
	{
		x: "2020-04-18",
		y: 116,
	},
	{
		x: "2020-04-19",
		y: 112,
	},
	{
		x: "2020-04-20",
		y: 112,
	},
	{
		x: "2020-04-21",
		y: 102,
	},
	{
		x: "2020-04-22",
		y: 115,
	},
	{
		x: "2020-04-23",
		y: 120,
	},
	{
		x: "2020-04-24",
		y: 118,
	},
];

// Data
export const TOP_SALES_LIST = [
	{
		type: "Point of sales",
		value: 4531.99,
		percentage: 23.7,
		up: false,
		icon: "paid",
	},
	{
		type: "Online store",
		value: 12023.76,
		percentage: 78.5,
		up: true,
		icon: "local_mall",
	},
	{
		type: "Mobile application",
		value: 2998.91,
		percentage: 65.3,
		up: true,
		icon: "phone_iphone",
	},
	{
		type: "CTA buy button",
		value: 894.32,
		percentage: 90.2,
		up: false,
		icon: "ads_click",
	},
	{
		type: "Draft orders",
		value: 2654.22,
		percentage: 40.1,
		up: false,
		icon: "draft_orders",
	},
];
